import { render, staticRenderFns } from "./Datasource.vue?vue&type=template&id=57810f34&scoped=true&"
import script from "./Datasource.vue?vue&type=script&lang=js&"
export * from "./Datasource.vue?vue&type=script&lang=js&"
import style0 from "./Datasource.vue?vue&type=style&index=0&id=57810f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57810f34",
  null
  
)

export default component.exports